<template>
  <tr
    :class="{ 'boss-table-4-selected': !applicantObject.applicant.isRead }"
    data-test="tr-show"
  >
    <td
      class="boss-center pega-input"
      data-test="check"
      @click="applicantObject.isChecked = !applicantObject.isChecked; updateChecked();"
    >
      <input
        data-role="select-user"
        type="checkbox"
        class="boss-input-checkbox"
        :checked="applicantObject.isChecked"
      >
    </td>
    <td
      class="boss-center boss-table-4-link-cell"
    >
      <router-link
        :to="{ name: 'applicantDetail', params: { entryId: applicantObject.applicant.id, tabKey: 'resume' } }"
        data-test="date"
        class="boss-table-4-link"
      >
        {{ applicationDate }}
        <div data-test="time">
          {{ applicationTime }}
        </div>
      </router-link>
      <span
        v-if="applicantObject.applicant.isCasualInterviewRequest"
        class="pega-casual-interview-request-icon"
        data-test="label-casual-interview-request"
      >話を聞きたい</span>
    </td>
    <td class="boss-center">
      <router-link
        :to="{ name: 'applicantDetail', params: { entryId: applicantObject.applicant.id, tabKey: 'resume' } }"
        data-test="user-id"
        class="boss-table-4-link boss-table-4-link-has-mark"
      >
        ID:{{ applicantObject.applicant.user.id }}
        <span v-if="applicantObject.applicant.user.isDuplicatedEntries"><br><span
          v-tooltip="{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。', trigger: 'hover' }"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募</span></span>
        <div data-test="member-name">
          {{ memberName }}
        </div>
        <div data-test="member-summary">
          {{ memberSummary }}
        </div>
      </router-link>
    </td>
    <td class="is-boss-only-pc">
      <router-link
        :to="{ name: 'applicantDetail', params: { entryId: applicantObject.applicant.id, tabKey: 'resume' } }"
        data-test="job-id"
        class="boss-table-4-link"
      >
        求人ID:{{ applicantObject.applicant.job.id }}
        <div data-test="job-name">
          {{ jobName }}
        </div>
      </router-link>
    </td>
    <td class="boss-center">
      <div class="boss-layout boss-layout-vertical">
        <div>
          <div class="boss-layout boss-layout-gap-small">
            <div
              v-if="applicantObject.applicant.approachingStatus.scout.isSend"
            >
              <img
                v-tooltip="{ content: 'スカウト'}"
                :class="{ 'boss-icon-end': !applicantObject.applicant.approachingStatus.scout.isEffective }"
                src="../../assets/images/icon-scout.svg"
                data-test="scout-icon"
              >
            </div>
            <div
              v-if="applicantObject.applicant.approachingStatus.offerDm.isSend"
            >
              <img
                v-tooltip="{ content: 'オファーDM'}"
                :class="{ 'boss-icon-end': !applicantObject.applicant.approachingStatus.offerDm.isEffective }"
                src="../../assets/images/icon-offer-dm.svg"
                data-test="dm-icon"
              >
            </div>
            <div
              v-if="applicantObject.applicant.approachingStatus.liked.isSend"
            >
              <img
                v-tooltip="{ content: 'いいね'}"
                :class="{ 'boss-icon-end': !applicantObject.applicant.approachingStatus.liked.isEffective }"
                src="../../assets/images/icon-like.svg"
                data-test="like-icon"
              >
            </div>
          </div>
        </div>
        <div>
          <div class="boss-layout boss-layout-vertical boss-layout-no-gap">
            <div
              v-for="sendingFavor in applicantObject.applicant.approachingStatus.specialFavors"
              :key="sendingFavor.id"
            >
              <span
                v-tooltip="{ content: specialFavorBy(sendingFavor.id).description}"
                :data-test="'special-favor-' + sendingFavor.id"
                :class="{ 'boss-bonus-end': !sendingFavor.isEffective }"
                class="boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true"
              >{{ sendingFavor.name }}</span>
            </div>
          </div>
          <span
            v-if="pathwayLabel"
            class="pega-dtype-scout-check pega-check-true"
            data-test="label-pathway"
          >{{ pathwayLabel }}</span>
        </div>
      </div>
    </td>
    <message-icon-information
      :message="applicantObject.applicant.message"
      :entry-id="applicantObject.applicant.id"
    />
    <template v-for="(displayItem) in displayItems">
      <td
        v-if="displayItem === 'phase'"
        :key="'outline-' + displayItem"
        class="boss-center is-boss-only-pc"
        data-test="phase"
      >
        <select
          v-model="applicantObject.applicant.currentSelection.phaseId"
          class="boss-input-select js-check-default"
          data-default
          data-test="selection-phase"
          @change="updateSelectionPhase"
        >
          <option
            v-for="(selectionPhase ,i) in phases"
            :key="i"
            :value="selectionPhase.id"
          >
            {{ selectionPhase.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'status'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="status"
      >
        <select
          v-model="applicantObject.applicant.currentSelection.statusId"
          class="boss-input-select js-check-default"
          data-default
          data-test="selection-status"
          @change="updateSelectionStatus"
        >
          <option :value="null">
            ー
          </option>
          <option
            v-for="(selectionStatus ,i) in allStatuses"
            :key="i"
            :value="selectionStatus.id"
          >
            {{ selectionStatus.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'remarks'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc boss-table-cell-has-textarea pega-position-inherit"
        data-test="remarks"
      >
        <textarea
          :value="applicantObject.applicant.remarks"
          class="boss-textarea-in-table"
          rows="5"
          data-test="text-remarks"
          @change="updateRemarks"
        />
      </td>
      <td
        v-if="displayItem === 'responsible_staffs'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="responsible-staffs"
      >
        <select
          v-model.number="applicantObject.applicant.responsibleStaffId"
          class="boss-input-select js-check-default"
          data-test="select-responsible-staffs"
          @change="updateResponsibleStaff"
        >
          <option :value="null">
            ー
          </option>
          <option
            v-for="staff in responsibles"
            :key="staff.id"
            :value="staff.id"
          >
            {{ staff.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'evaluation'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="evaluation-name"
      >
        {{ evaluationName }}
      </td>
      <td
        v-if="displayItem === 'comment'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc pega-pre-wrap pega-break"
        data-test="evaluation-comment"
        v-text="applicantObject.applicant.currentSelection.evaluationComment || 'ー'"
      />
    </template>
  </tr>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import _ from 'lodash'
import * as parse from '@/lib/parse'
import { mapGetters } from 'vuex'
import cartInAnimation from '@/lib/cartInAnimation'
import { directTypeLabelContainLF } from '@/lib/labelValueMappings'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    applicantObject: {
      type: Object,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    },
    displayItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('settings', [
      'phases',
      'allStatuses',
      'responsibles',
      'fixedStatuses'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    applicationDate () {
      return createDate(_.get(this.applicantObject, 'applicant.entryDate'))?.format('YY/MM/DD')
    },
    applicationTime () {
      return createDate(_.get(this.applicantObject, 'applicant.entryDate'))?.format('HH:mm')
    },
    memberSummary () {
      const summaries = [_.get(this.applicantObject, 'applicant.user.prefecture.name'), this.getAge(_.get(this.applicantObject, 'applicant.user.birthday')), _.get(this.applicantObject, 'applicant.user.gender.name')]
      return _(summaries).compact().join(' ')
    },
    memberName () {
      return this.applicantObject.applicant.user.lastName + this.applicantObject.applicant.user.firstName
    },
    evaluationName () {
      return _.get(this.applicantObject.applicant.currentSelection.evaluation, 'name', '') || 'ー'
    },
    jobName () {
      if (this.applicantObject.applicant.job.name.length > 20) {
        return this.applicantObject.applicant.job.name.match(/^.{0,20}/) + '...'
      } else {
        return this.applicantObject.applicant.job.name
      }
    },
    pathwayLabel () {
      return _.get(directTypeLabelContainLF, this.applicantObject.applicant.pathway, '')
    }
  },
  methods: {
    updateChecked () {
      this.$emit('update-checked', { id: this.applicantObject.applicant.id, isChecked: this.applicantObject.isChecked })
    },
    updateRemarks (e) {
      this.$set(this.applicantObject.applicant, 'remarks', e.target.value)
      this.$http.secured.put('/entry/view/entries/remarks',
        {
          entryIds: [this.applicantObject.applicant.id],
          remarks: this.applicantObject.applicant.remarks
        }
      ).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '備考を更新しました。' })
      })
    },
    updateSelectionPhase () {
      this.$http.secured.put('/entry/view/entries/phases',
        {
          entryIds: [this.applicantObject.applicant.id],
          itemId: this.applicantObject.applicant.currentSelection.phaseId
        }
      ).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '選考フェーズを更新しました。' })
        this.$emit('update-selections', this.applicantObject.applicant.id)
      })
    },
    updateSelectionStatus () {
      this.$http.secured.put('/entry/view/entries/phase_statuses',
        {
          entryIds: [this.applicantObject.applicant.id],
          itemId: this.applicantObject.applicant.currentSelection.statusId
        }
      ).then(response => {
        const targetElementId = _.includes(this.fixedStatuses.map(status => status.id), this.applicantObject.applicant.currentSelection.statusId)
          ? `#display-target-${this.applicantObject.applicant.currentSelection.statusId}` : ''
        this.$toasted.global.successRightTopSingleton(
          {
            message: `選考ステータスを更新しました。${targetElementId ? `<br>画面右上の「${this.getFixedStatusesName(this.applicantObject.applicant.currentSelection.statusId)}」ボタンをONにした場合のみ表示されます。` : ''}`
          }
        )
        targetElementId && cartInAnimation.start(_.includes(this.displayTarget, this.applicantObject.applicant.currentSelection.statusId) ? this.$el : '#applicant-applicants', targetElementId)
        this.$emit('update-selections', this.applicantObject.applicant.id)
      })
    },
    updateResponsibleStaff () {
      this.$http.secured.put('/entry/view/entries/responsible_staffs', {
        entryIds: [this.applicantObject.applicant.id], itemId: this.applicantObject.applicant.responsibleStaffId
      }).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '人事担当を更新しました。' })
      })
    },
    getFixedStatusesName (statusId) {
      return this.fixedStatuses.find(status => _.isEqual(status.id, statusId)).name
    },
    getAge (birthdateString) {
      return birthdateString ? parse.age(birthdateString) + '歳' : ''
    }
  }
}
</script>
